<div class="flex flex-col md:flex-row justify-center mt-4 text-blue1 gap-10"
     *transloco="let t; read: 'user.subscription.plan_selection'">
  <div *ngFor="let plan of plans" class="flex flex-col gap-4 text-blue1 max-w-lg rounded-xl bg-sun-yellow bg-opacity-10 p-4">
    <!--   t(business.title, business.description) -->
    <!--   t(business_plus.title, business_plus.description) -->
    <div class="text-2xl font-bold">
      {{t(plan.translationGroup + '.title')}}
    </div>
    <psc-loader *ngIf="loading"></psc-loader>
    <div *ngIf="!loading" class="font-bold text-sun-yellow">
      {{plan.price}} {{plan.currency}}/{{t('monthly')}}
    </div>
    <div>
      {{t(plan.translationGroup + '.description')}}
    </div>
    <div class="text-blue2 font-bold flex justify-end items-center pr-2">
      <ng-container *ngIf="(plan.role | userHasRole) && subscription?.autoRenewalActive; else choosePlanButton">
        {{t('plan_selected')}}
      </ng-container>
      <ng-template #choosePlanButton>
        <psc-button
          size="small"
          type="primary-blue-2"
          [label]="t('choose_plan')"
          (buttonClicked)="choosePlan(plan.role)">
        </psc-button>
      </ng-template>
    </div>
  </div>
</div>
